export default "__VITE_ASSET__twUM92TZ__"